// @ts-ignore
import $i18n from '@/i18n';
import React, { useEffect, useMemo } from 'react';
import { useState } from 'react'
import { Table, Message, Input, Icon } from '@b-design/fusion';
import { Balloon } from '@alifd/next';
import Button from '@/components/Button';
import { CloseOutlined } from '@ant-design/icons';
import PaginationComponent from '@/components/PaginationComponent';
import style from './style.module.less'
import './index.less'
import { tableColumons } from './config'
import { getJsApiApplyListForChannel, applyJsApiForChannel } from '@/services/jsapiAuth'
import { useRowSelection } from './useRowSelection'
import { openJsapiAuthChannel } from '../index'
import lodash from 'lodash';

interface IApplyRecord {
  uid: string;
  jsapiName: string;
  functionDesc: string;
  channelCode: string
  channelName: string;
  supportSystem: string[];
  controlStatus: "CONTROLLED" | "UNCONTROLLED"
  isApply: number
}

interface IDataSource {
  list: IApplyRecord[],
  total: number
}

interface JsApiApplyTableProps {
  spaceId: string;
  appId: string
  openJsApiAuthChannels: openJsapiAuthChannel[]
  contentHeight?: number
  closeDialog?: () => void,
  refresh: () => void
}


const JsAPIApplyTable = (props: JsApiApplyTableProps): JSX.Element | undefined => {
  const { contentHeight = 560, closeDialog, openJsApiAuthChannels, spaceId, appId, refresh: refreshApplyTable } = props;
  const [dataSource, setDataSource] = useState<IDataSource>({ list: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [ballonVisible, setBallonVisible] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [inputValue, setInputValue] = useState('')

  // filter
  const [filterValue, setFilterValue] = useState(
    {
      "channelName": {
        "selectedKeys": [
          ""
        ]
      }
    }
  );
  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });


  const {
    rowSelection,
    selectedSize, //选中的数量
    allSelectedRecords, // 获取已选中的记录
    allSelectedIds, // 获取已选中的记录ID
    clearSelectedRecords,

  } = useRowSelection<IApplyRecord>(dataSource, (record) => ("uid"), (record) => !!record.isApply)


  const fetchData = (pageSize: number, pageNumber: number, channelCode?: string, jsapiName?: string) => {
    setLoading(true)
    /**
     * channelCode=xx // 渠道code
  spaceId=xx // 空间code
  appId=xx // 小程序ID
  currentPage=1 // 当前页
  pageSize=10 // 一页几条
  jsapiName:""// 可选名称搜索
     */

    getJsApiApplyListForChannel({
      jsapiName,
      channelCode,
      spaceId,
      appId,
      currentPage: pageNumber,
      pageSize,
    }).then(res => {
      if (res) {
        const withUidList = res.list?.map(item => ({ ...item, uid: `${item.jsapiName}${item.channelCode}` }))
        setDataSource({
          list: withUidList,
          total: res.total
        })
        setPaginationValue({
          currentPage: res.current,
          pageSize: res.pageSize
        })
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const refresh = (pageSize: number, pageNumber: number) => {
    setFilterValue({
      channelName: {
        selectedKeys: ['']
      }
    })
    fetchData(pageSize, pageNumber, filterValue?.channelName.selectedKeys[0], inputValue)
  }


  useEffect(() => {
    fetchData(paginationValue.pageSize, paginationValue.currentPage, filterValue?.channelName.selectedKeys[0], inputValue)
  }, [paginationValue.currentPage, paginationValue.pageSize])

  useEffect(() => {
    fetchData(paginationValue.pageSize, 1, filterValue?.channelName.selectedKeys[0], inputValue)
  }, [filterValue])

  const baseStyle = {
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '1.25px',
    lineHeight: '24px',
    padding: '0px 16px',
    borderRadius: '2px'
  }


  const onCancel = () => {
    closeDialog?.()
  }
  const reset = () => {
    clearSelectedRecords()
    setBallonVisible(false)
  }

  const onSubmitApply = () => {
    setSubmitLoading(true)
    const group = lodash.groupBy(allSelectedRecords, (item: any) => item.channelCode)

    const applyJsapiList = allSelectedRecords.map(item => ({
      jsapiName: item.jsapiName,
      channelCode: item.channelCode,
    }))


    return applyJsApiForChannel({
      spaceId,
      appId,
      applyJsapiList
    }).then(res => {
      if (res) {
        Message.success($i18n.get({
          id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.Message",
          dm: "申请已提交，请稍等"
        }))
        reset()
        refresh(paginationValue.pageSize, 1)
        refreshApplyTable()
      }
    }).finally(() => {
      setSubmitLoading(false)
      closeDialog?.()
    })
  }

  const content = () => {
    return (<div style={{ position: 'relative', padding: 16 }}>
      <div style={{
        fontWeight: 500,
        fontSize: 14,
        color: "#121C2D",
        lineHeight: '24px',
        height: '24px',
        letterSpacing: 0.15,
        position: 'relative'
      }}>{$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.addTitle", dm: "请再次确认" })} <CloseOutlined onClick={() => setBallonVisible(false)} style={{ fontSize: 10, position: 'absolute', right: 0, color: '#474A52' }} /></div>
      <div style={{
        color: "#474A52",
        textAlign: 'left',
        lineHeight: '16px',
        fontWeight: 400,
        fontSize: 12,
        letterSpacing: 0.4,

      }}>
        {$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.addTip", dm: "请确认，您已选择的{count} 条 JSAPI 是必要的，否则会影响整体的审批通过状态" }, { count: selectedSize, s: selectedSize > 1 ? 's' : '' })}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
        <Button type="normal" size={'small'} style={{ marginRight: 16, ...baseStyle, fontSize: 12 }} onClick={() => setBallonVisible(false)} >{$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.cancel", dm: "取消" })}</Button>
        <Button type="primary" size={'small'} style={{ ...baseStyle, fontSize: 12 }} loading={submitLoading} onClick={() => onSubmitApply()} >{$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.ok", dm: "确定" })}</Button>
      </div>
    </div>)
  }


  const openJsApiAuthChannelsTransToMap = useMemo(() => {
    return openJsApiAuthChannels.reduce((acc, cur) => {
      acc[cur.innerCode] = cur.name
      return acc
    }, {})
  }, [openJsApiAuthChannels])


  const onSerch = (v) => {
    setFilterValue({
      "channelName": {
        "selectedKeys": [
          ""
        ]
      }
    })
    clearSelectedRecords()
    fetchData(paginationValue.pageSize, 1, filterValue.channelName.selectedKeys[0], inputValue)
  }

  const search = () => {
    return (<Input
      value={inputValue}
      onChange={setInputValue}
      placeholder={$i18n.get({ id: 'aopf.pages.miniapp.input.Search', dm: '搜索...' })}
      style={{ marginBottom: 16, width: '100%' }}
      innerBefore={<Icon type="search" style={{ margin: 4, cursor: 'pointer' }} onClick={onSerch}

      />}
    />)
  }

  return (<div style={{ width: '100%', paddingBottom: 40 }}>
    <div>
      <div className="jsapi-auth-table-content" style={{ position: 'relative', padding: 0 }}>
        <Table.StickyLock
          className="jsapi-auth-table"
          primaryKey="uid"
          columns={tableColumons(openJsApiAuthChannelsTransToMap)}
          dataSource={dataSource?.list}
          rowSelection={rowSelection}
          fixedHeader
          hasBorder={false}
          maxBodyHeight={'calc(100vh - 400px)'}
          loading={loading}
          onFilter={(filterParams) => {
            setFilterValue(filterParams);
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div className={style.toatlText} style={{ height: 32, display: 'flex', flexFlow: 'row', justifyContent: 'center', alignItems: 'center' }}>{`${selectedSize} / ${dataSource.total}`}</div>
          <PaginationComponent
            total={dataSource?.total}
            current={paginationValue?.currentPage}
            pageSize={paginationValue?.pageSize}
            onPageChange={(current, pageSize) => {
              setPaginationValue({
                currentPage: current,
                pageSize,
              });
            }}
          />
        </div>
      </div>

    </div>
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
      <Button type="normal" style={{ marginRight: 16, ...baseStyle }} onClick={onCancel} >{$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.cancel", dm: "取消" })}</Button>
      <Balloon visible={ballonVisible} closable={false} v2
        trigger={<Button disabled={selectedSize === 0} onClick={() => setBallonVisible(true)} type="primary" style={{ ...baseStyle }}>{$i18n.get({ id: "aopf.pages.miniapp.detail.tab.jsapiFeaturs.applyDialog.btn.add", dm: "申请" })}</Button>} align="t" triggerType="click" style={{
          width: 317,
          ["--balloon-normal-shadow"]: "0 4px 16px 0 rgba(0, 0, 0, .12)",
          ["--balloon-size-arrow-expose"]: '-4px'
        }}>
        {content()}
      </Balloon>

    </div>
  </div>)

}

export default JsAPIApplyTable;